import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { PageHeader, Empty } from "@/components/kit";

const KINDS = { info: "Informativo", warning: "Aviso importante", security: "Segurança", finance: "Financeiro", trade: "Negociação" };

export default function AdminNotifications() {
  const [f, setF] = useState({ target: "all", user_id: "", title: "", body: "", kind: "info" });
  const [clients, setClients] = useState([]);
  const [sent, setSent] = useState([]);
  const load = () => api.get("/admin/notifications").then((r) => setSent(r.data));
  useEffect(() => {
    load();
    api.get("/admin/clients").then((r) => setClients(r.data)).catch(() => {});
  }, []);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/notifications", { ...f, user_id: f.target === "user" ? f.user_id : null }); toast.success("Comunicado enviado"); setF({ ...f, title: "", body: "" }); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div data-testid="admin-notifications-page">
      <PageHeader eyebrow="Comunicação" title="Notificações e comunicados" desc="Envie avisos para todos os clientes ou para um cliente específico." />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        <form onSubmit={submit} className="surface p-5 md:p-7 space-y-4 lg:col-span-5" data-testid="announcement-form">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Destino</Label>
              <Select value={f.target} onValueChange={(v) => setF({ ...f, target: v })}><SelectTrigger className="h-11" data-testid="announcement-target-select"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="all">Todos os clientes</SelectItem><SelectItem value="user">Cliente específico</SelectItem></SelectContent></Select></div>
            <div className="space-y-1.5"><Label>Tipo</Label>
              <Select value={f.kind} onValueChange={(v) => setF({ ...f, kind: v })}><SelectTrigger className="h-11" data-testid="announcement-kind-select"><SelectValue /></SelectTrigger>
                <SelectContent>{Object.entries(KINDS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent></Select></div>
          </div>
          {f.target === "user" && (
            <Select value={f.user_id} onValueChange={(v) => setF({ ...f, user_id: v })}><SelectTrigger className="h-11" data-testid="announcement-user-select"><SelectValue placeholder="Selecione o cliente" /></SelectTrigger>
              <SelectContent>{clients.map((c) => <SelectItem key={c.id} value={c.id}>{c.client_code} · {c.name}</SelectItem>)}</SelectContent></Select>
          )}
          <div className="space-y-1.5"><Label>Título</Label><Input required className="h-11" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="announcement-title-input" /></div>
          <div className="space-y-1.5"><Label>Mensagem</Label><Textarea required rows={5} value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} data-testid="announcement-body-input" /></div>
          <Button className="h-11 w-full" data-testid="announcement-submit">Enviar comunicado</Button>
        </form>
        <div className="surface lg:col-span-7 divide-y divide-border" data-testid="announcements-list">
          <div className="eyebrow p-5">Enviados</div>
          {sent.length === 0 && <Empty text="Nenhum comunicado enviado." />}
          {sent.map((s) => (
            <div key={s.id} className="p-5"><div className="flex justify-between gap-3"><span className="font-semibold">{s.title}</span><span className="text-xs text-muted-foreground">{fmtDateTime(s.created_at)}</span></div>
              <p className="text-sm text-muted-foreground mt-1">{s.body}</p>
              <p className="text-xs mt-1">{s.target === "all" ? "Todos os clientes" : `Cliente ${s.user_id}`} · {KINDS[s.kind]} · por {s.sent_by}</p></div>
          ))}
        </div>
      </div>
    </div>
  );
}
